"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Message = function Message(cmd, seq, version, body) {
    _classCallCheck(this, Message);

    this.Cmd = cmd;
    this.Seq = seq;
    this.Version = version;
    this.Body = body;
};

var BaseMessage = function () {
    function BaseMessage() {
        _classCallCheck(this, BaseMessage);

        this.body = {};
    }

    _createClass(BaseMessage, [{
        key: "toString",
        value: function toString() {
            return JSON.stringify(this.body);
        }
    }]);

    return BaseMessage;
}();

var IMMessage = function (_BaseMessage) {
    _inherits(IMMessage, _BaseMessage);

    function IMMessage(FromUsername, Receiver, Content) {
        _classCallCheck(this, IMMessage);

        var _this = _possibleConstructorReturn(this, (IMMessage.__proto__ || Object.getPrototypeOf(IMMessage)).call(this));

        _this.body.FromUsername = FromUsername;
        _this.body.Receiver = Receiver;
        _this.body.Content = Content;
        return _this;
    }

    return IMMessage;
}(BaseMessage);

var Room = function (_BaseMessage2) {
    _inherits(Room, _BaseMessage2);

    function Room(roomid) {
        _classCallCheck(this, Room);

        var _this2 = _possibleConstructorReturn(this, (Room.__proto__ || Object.getPrototypeOf(Room)).call(this));

        _this2.body = {};
        _this2.body.RoomId = roomid;
        return _this2;
    }

    return Room;
}(BaseMessage);

var RoomMessage = function (_BaseMessage3) {
    _inherits(RoomMessage, _BaseMessage3);

    function RoomMessage(FromUsername, roomId, Content) {
        _classCallCheck(this, RoomMessage);

        var _this3 = _possibleConstructorReturn(this, (RoomMessage.__proto__ || Object.getPrototypeOf(RoomMessage)).call(this));

        _this3.body = {};
        _this3.body.FromUsername = FromUsername;
        _this3.body.Receiver = roomId;
        _this3.body.Content = Content;
        return _this3;
    }

    return RoomMessage;
}(BaseMessage);

var AuthTokenMessage = function (_BaseMessage4) {
    _inherits(AuthTokenMessage, _BaseMessage4);

    function AuthTokenMessage(Appkey, Username, UserToken, DeviceId, PlatformId) {
        _classCallCheck(this, AuthTokenMessage);

        var _this4 = _possibleConstructorReturn(this, (AuthTokenMessage.__proto__ || Object.getPrototypeOf(AuthTokenMessage)).call(this));

        _this4.body.Appkey = Appkey;
        _this4.body.Username = Username;
        _this4.body.UserToken = UserToken;
        _this4.body.DeviceId = DeviceId;
        _this4.body.PlatformId = PlatformId;
        return _this4;
    }

    return AuthTokenMessage;
}(BaseMessage);

var SyncKeyMessage = function (_BaseMessage5) {
    _inherits(SyncKeyMessage, _BaseMessage5);

    function SyncKeyMessage(sync_key) {
        _classCallCheck(this, SyncKeyMessage);

        var _this5 = _possibleConstructorReturn(this, (SyncKeyMessage.__proto__ || Object.getPrototypeOf(SyncKeyMessage)).call(this));

        _this5.body.SyncKey = sync_key;
        return _this5;
    }

    return SyncKeyMessage;
}(BaseMessage);

var GroupSyncKeyMessage = function (_BaseMessage6) {
    _inherits(GroupSyncKeyMessage, _BaseMessage6);

    function GroupSyncKeyMessage(sync_key, group_id) {
        _classCallCheck(this, GroupSyncKeyMessage);

        var _this6 = _possibleConstructorReturn(this, (GroupSyncKeyMessage.__proto__ || Object.getPrototypeOf(GroupSyncKeyMessage)).call(this));

        _this6.body.SyncKey = sync_key;
        _this6.body.GroupId = group_id;
        return _this6;
    }

    return GroupSyncKeyMessage;
}(BaseMessage);

var TransMessage = function (_BaseMessage7) {
    _inherits(TransMessage, _BaseMessage7);

    function TransMessage(FromUsername, Receiver, Content, Type) {
        _classCallCheck(this, TransMessage);

        var _this7 = _possibleConstructorReturn(this, (TransMessage.__proto__ || Object.getPrototypeOf(TransMessage)).call(this));

        _this7.body.FromUsername = FromUsername;
        _this7.body.Receiver = Receiver;
        _this7.body.Content = Content;
        _this7.body.Type = Type;
        return _this7;
    }

    return TransMessage;
}(BaseMessage);

var ModifyMessage = function (_BaseMessage8) {
    _inherits(ModifyMessage, _BaseMessage8);

    function ModifyMessage(FromUsername, RoomId, Type, Key, Value) {
        _classCallCheck(this, ModifyMessage);

        var _this8 = _possibleConstructorReturn(this, (ModifyMessage.__proto__ || Object.getPrototypeOf(ModifyMessage)).call(this));

        _this8.body.FromUsername = FromUsername;
        _this8.body.RoomId = RoomId;
        _this8.body.Type = Type; // 'set'  'incr'
        _this8.body.Key = Key;
        _this8.body.Value = Value;
        return _this8;
    }

    return ModifyMessage;
}(BaseMessage);

var HeartBeatMessage = function (_BaseMessage9) {
    _inherits(HeartBeatMessage, _BaseMessage9);

    function HeartBeatMessage() {
        _classCallCheck(this, HeartBeatMessage);

        return _possibleConstructorReturn(this, (HeartBeatMessage.__proto__ || Object.getPrototypeOf(HeartBeatMessage)).call(this));
    }

    return HeartBeatMessage;
}(BaseMessage);

exports.Message = Message;
exports.IMMessage = IMMessage;
exports.RoomMessage = RoomMessage;
exports.AuthTokenMessage = AuthTokenMessage;
exports.HeartBeatMessage = HeartBeatMessage;
exports.SyncKeyMessage = SyncKeyMessage;
exports.GroupSyncKeyMessage = GroupSyncKeyMessage;
exports.Room = Room;
exports.TransMessage = TransMessage;
exports.ModifyMessage = ModifyMessage;
//# sourceMappingURL=message.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/message.js
// module id = SDrH
// module chunks = 0